import { render, staticRenderFns } from "./GeneralInfoBlock.vue?vue&type=template&id=cebbe2c4&scoped=true&"
import script from "./GeneralInfoBlock.vue?vue&type=script&lang=js&"
export * from "./GeneralInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./GeneralInfoBlock.vue?vue&type=style&index=0&id=cebbe2c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebbe2c4",
  null
  
)

export default component.exports